import angular from 'angular';
import uiRouter from 'angular-ui-router';
import botSessionsComponent from './bot-sessions.component';

let botSessionsModule = angular.module('app.containers.bot-sessions', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('botSessions', {
      url: '/bot-sessions',
      template: '<bot-sessions></bot-sessions>'
    });
})

.component('botSessions', botSessionsComponent);

export default botSessionsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-sessions/bot-sessions.js
 **/